export default {"src":"/_next/static/media/v7.d09617c2.svg","height":130,"width":332};